import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Services } from "./components/services";
import { FeatureStrip } from "./components/featureStrip";
import { BottomBar } from "./components/bottomBar";
import { Booking } from "./components/booking";
import { Vehicle } from "./components/vehicle";
import { Tarifs } from "./components/tarifs";
import { Zones } from "./components/zones";
import { About } from "./components/about";
import { Faq } from "./components/faq";
import { Testimonials } from "./components/testimonials";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";
import Devis from "./components/devis";
import { RamassageScolaire } from "./components/ramassageScolaire";

import JsonData from "./data/data.json";
import "./App.css";

const Home = () => (
  <>
    <Header data={JsonData.Header} brand={JsonData.Brand} vehicle={JsonData.Vehicle} />
    <Services data={JsonData.Services} />
    <FeatureStrip brand={JsonData.Brand} />

    <div className="container split">
      <Booking />
      <Vehicle data={JsonData.Vehicle} />
    </div>

    <Tarifs />
    <Zones data={JsonData.Zones} />

    <div className="container">
      <About data={JsonData.About} />
    </div>

    <Faq data={JsonData.Faq} />
    <Testimonials data={JsonData.Testimonials} />
    <Contact data={JsonData.Brand} />
    <BottomBar />
  </>
);

const App = () => (
  <Router>
    <Navigation data={JsonData.Nav} brand={JsonData.Brand} />
    <main>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/ramassage-scolaire"
          element={<RamassageScolaire brand={JsonData.Brand} vehicle={JsonData.Vehicle} />}
        />
        <Route path="/devis/:leadId" element={<Devis />} />
      </Routes>
    </main>
    <Footer data={JsonData.Footer} brand={JsonData.Brand} />
  </Router>
);

export default App;
